import { createTheme, ThemeProvider, styled } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#A1C5D2', // Main part that show page details
      dark: "#48636c", // left and top menus
      // contrastText: will be calculated to contrast with palette.primary.main
      contrastText: '#011a2a',
    },
    secondary: {
      //light: ,
      main: '#222e47',
      dark: '#182035',
      contrastText: '#5fb66b',
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
});
